const headerWrapper = document.querySelector('header');

let lastScrollY = window.scrollY;
let headerHeight = headerWrapper.offsetHeight;

if (lastScrollY > headerHeight) {
    headerWrapper.classList.remove('header_sticky');
}

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY) {
        if (currentScrollY > headerHeight) {
            headerWrapper.classList.add('header_sticky');
        } else {
            headerWrapper.classList.remove('header_sticky');
        }
    } else {
        if (currentScrollY > headerHeight) {
            headerWrapper.classList.remove('header_sticky');
        }
    }

    lastScrollY = currentScrollY;
});

$('[data-video-url]').on('click', (el) => {
    const videoUrl = el.currentTarget.dataset.videoUrl;
    if (videoUrl) {
        const video = document.createElement('video');
        video.controls = false;
        video.muted = true;
        const source = document.createElement('source');
        source.src = videoUrl;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.height = el.currentTarget.parentElement.offsetHeight;
        video.width = el.currentTarget.parentElement.offsetWidth;
        video.style.objectFit = 'cover';
        $(el.currentTarget.parentElement).find('*').hide();
        el.currentTarget.parentElement.appendChild(video);
        video.play();
    }
});

$('.qft-footer-title-wrap').on('click', (el) => {
    $(el.currentTarget.nextElementSibling).toggle().toggleClass('active');
    $(el.currentTarget).find('.qft-footer-title-icn').toggle();
});

Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
$('.qft-col-wrap').on('click', (el) => {
    $('#' + el.currentTarget.dataset.target).toggle('fast');
})

// window.addEventListener('click', (event) => {
//     if (!event.target.matches('.sortWrapOption')) {
//         $('#sortwrap').toggle('fast');
//     }
// });
$('.sortWrapOption').on('click', (el) => {
    document.getElementById('SortBy').value = el.currentTarget.dataset.target;
    const cstmEvent = new Event('input');
    document.querySelector('#FacetSortForm').dispatchEvent(cstmEvent);
});
// $('.mobile-facets__open-wrapper').click()
$(document).ready(function () {
    /* ---------------------------- Start: Menu Drawer ---------------------------- */
    $("[data-menu_icon], [data-search-button-mbl]").on("click", function () {
        const isMenu = $(this).is("[data-menu_icon]");
        const key = isMenu ? "menu_icon" : "search-button-mbl";
        const $drawer = $(`[data-drawer-wrapper][data-${key}]`);
        const $overlay = $(`#${isMenu ? "menu" : "search"}_drawer_overlay`);
        $("[data-drawer-wrapper].active, [data-drawer-overlay].active").removeClass("active");
        requestAnimationFrame(() => {
            $drawer.add($overlay).addClass("active");
            $('body').addClass('qft-overflow-hidden');
            setTimeout(() => {
                const $navItems = $drawer.find('.main_menu_option > .mobile-nav__item');
                const $accountWrapper = $drawer.find('.account_option_wrapper');
                $navItems.each(function (index) {
                    const $item = $(this);
                    setTimeout(() => {
                        $item.addClass('animate-in');
                    }, index * 120); // Har item 120ms delay se aayega
                });
                const totalNavDelay = ($navItems.length - 1) * 120; // Last nav item ka delay
                const navAnimationDuration = 400; // CSS transition duration
                setTimeout(() => {
                    $accountWrapper.addClass('animate-in');
                }, totalNavDelay + navAnimationDuration + 100);
            }, 350); // Drawer open animation (300ms) + extra buffer (50ms)
        });
    });
    function closeDrawer($drawer) {
        const isMenu = $drawer.attr("data-menu_icon") !== undefined;
        const $overlay = $(`#${isMenu ? "menu" : "search"}_drawer_overlay`);
        $(".main_menu_option > .mobile-nav__item, .account_option_wrapper").removeClass("animate-in");
        $drawer.add($overlay).removeClass("active");
        $('body').removeClass('qft-overflow-hidden');
    }
    $("[data-drawer-close]").on("click", function (el) {
        el.stopPropagation();
        const $drawer = $(this).closest("[data-drawer-wrapper]");
        closeDrawer($drawer);
    });
    $("[data-drawer-overlay]").on("click", function () {
        const isMenu = $(this).attr("id") === "menu_drawer_overlay";
        const $drawer = $(`[data-drawer-wrapper][data-${isMenu ? "menu_icon" : "search-button-mbl"}]`);
        closeDrawer($drawer);
    });
    $(".mobile-nav__item-btn[type='button']").on("click", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $submenu = $btn.next("ul");
        const isOpen = $btn.attr("aria-expanded") === "true";
        // Find only siblings at the same level (not affecting parent or child levels)
        const $siblings = $btn.closest("ul").children(".mobile-nav__item").children(".mobile-nav__item-btn[aria-expanded='true']");
        // Close other open siblings at the same level
        $siblings.not($btn).each(function () {
            const $sibBtn = $(this);
            $sibBtn.attr("aria-expanded", "false");
            $sibBtn.next("ul").slideUp(200).attr("hidden", true);
        });
        // Toggle current submenu
        $btn.attr("aria-expanded", !isOpen);
        if (!isOpen) {
            $submenu.slideDown(200).attr("hidden", false);
        } else {
            $submenu.slideUp(200).attr("hidden", true);
        }
    });

    /* ---------------------------- End: Menu Drawer ---------------------------- */

    /* ---------------------------- Desktop Heading Menu ---------------------------- */
    let visibleBox = null;
    $('.head-opt > [data-target]').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('qft-overflow-hidden');
        let targetId = $(this).data('target');
        let $shopBox = $('#' + targetId);

        if (visibleBox && visibleBox.is($shopBox)) {
            $shopBox.stop(true, true).slideUp(200);
            visibleBox = null;
        } else {
            if (visibleBox) {
                visibleBox.stop(true, true).slideUp(200);
            }
            $shopBox.stop(true, true).slideDown(200);
            visibleBox = $shopBox;
        }
    });

    /* ---------------------------- Search Click Box ---------------------------- */
    $('.search').click(function (e) {
        e.stopPropagation();
        $('#desk_search_icon').css('display', 'none');
        $('.search-bx.desk-search-bx').css('display', 'flex');
        $('body').toggleClass('qft-overflow-hidden');
        $('#search-click-bx, #popup_overlay').slideToggle(200).css('display', 'block');
        $('.search-bar1').val('').focus();
    });
    $('#popup_overlay').click(function () {
        $('.search_recomand_product').removeClass('qft-none');
        $('.search_ul_wrap').removeClass('active');
        $('#desk_search_icon').css('display', 'flex');
        $('.search-bx.desk-search-bx').css('display', 'none');
        $('#search-click-bx, #popup_overlay').stop(true, true).slideUp(200);
        $('body').toggleClass('qft-overflow-hidden');
    });

    $('.clear-btn').click(function () {
        $('.search-bar1').val('').focus();
        $('#search-results-mbl').html('');
        $('.search-res').hide();
        $('.search_recomand_product').removeClass('qft-none');
        $('.search_ul_wrap').removeClass('active');
    });
    $('#search-input-desk').on('keyup', (el) => {
        $('.search-res').show();
        $('.search_btn_wrapper').show();
        let queryMbl = el.currentTarget.value;
        let searchResults = document.getElementById('search-results-mbl');
        let searchResultsBtnMbl = document.getElementById('search-btn-mbl');
        if (queryMbl.length < 3) {
            if (queryMbl.length == 0) {
                searchResults.innerHTML = '';
                searchResultsBtnMbl.style.display = 'none';
                $('.search-res').hide();
                return;  // Stop searching if query is less than 3 characters
            }
            else {
                searchResults.innerHTML = 'Enter at least 3 characters';
                searchResultsBtnMbl.style.display = 'none';
                return;  // Stop searching if query is less than 3 characters
            }
        } else {
            fetch('/search/suggest.json?q=' + queryMbl + '&resources[type]=product')
                .then(response => response.json())
                .then(data => {
                    searchResults.innerHTML = '';  // Clear previous results
                    // searchResultsMbl.innerHTML = '';  // Clear previous results
                    if (data.resources.results.products.length > 0) {
                        data.resources.results.products.forEach((product, index) => {
                            if (index < 6) {
                                let resultItem = document.createElement('div');
                                resultItem.className = 'predict_prdct_wrap';
                                let productTitle = product.title;
                                let productTitleSplit = productTitle.split('-');
                                let productUrl = product.url || `/products/${product.handle}`;
                                let productImage = product.image ? product.image : 'placeholder.jpg';
                                resultItem.innerHTML = `
                                <a href="${productUrl}" class="predict_prdct_wrap">
                                    <img src="${productImage}" alt="${productTitleSplit[0]}">
                                    <div class="predict_prdct_info">
                                        <h3 class="qft_prdct_title">${productTitleSplit[0]}</h3>
                                        <p class="qftItalicTitle">${productTitleSplit[1]}</p>
                                        <p class="qft_price_wrap">${Shopify.formatMoney(product.price)}</p>
                                    </div>
                                    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_122_8)">
                                            <path d="M12.9385 1L18.9999 7.06134M18.9999 7.06134L12.9385 13.1227M18.9999 7.06134H1" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g> 
                                        <defs>
                                            <clipPath id="clip0_122_8">
                                                <rect width="20" height="14" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>`;
                                searchResults.appendChild(resultItem);
                                // searchResultsMbl.appendChild(resultItem);
                            }
                        });
                        searchResultsBtnMbl.innerHTML = `Search ${queryMbl}`;
                        searchResultsBtnMbl.href = `/search?type=product&q=${queryMbl}`;
                        searchResultsBtnMbl.style.display = 'block';
                        $('.search-res').show();
                    } else {
                        searchResults.innerHTML = '<div>No products found</div>';
                        searchResultsBtn.style.display = 'none';
                        $('.search-res').show();
                        // searchResultsMbl.innerHTML = '<div>No products found</div>';
                        // searchResultsBtnMbl.style.display = 'none';
                    }
                })
                .catch(error => {
                    console.log('Error fetching predictive search results:', error);
                });
        }
    });
    $('#search-input-mbl').on('keyup', (el) => {
        $('.search_recomand_product').addClass('qft-none');
        $('.search_ul_wrap').addClass('active');
        // let queryDesk = document.getElementById('search-input-desk').value;
        let queryMbl = document.getElementById('search-input-mbl').value;
        let searchResults = document.getElementById('search-results');
        let searchResultsBtn = document.getElementById('search-btn');
        // let searchResultsMbl = document.getElementById('search-results-mbl');

        if (queryMbl.length < 3) {
            searchResults.innerHTML = '';
            // searchResultsMbl.innerHTML = '';
            return;  // Stop searching if query is less than 3 characters
        }
        // let query;
        // if (el.currentTarget.id == 'search-input-desk')
        //     query = queryDesk;
        // else if (el.currentTarget.id == 'search-input-mbl')
        //     query = queryMbl;

        fetch('/search/suggest.json?q=' + queryMbl + '&resources[type]=product')
            .then(response => response.json())
            .then(data => {
                searchResults.innerHTML = '';  // Clear previous results
                // searchResultsMbl.innerHTML = '';  // Clear previous results
                if (data.resources.results.products.length > 0) {
                    data.resources.results.products.forEach((product, index) => {
                        if (index < 6) {
                            let resultItem = document.createElement('div');
                            resultItem.className = 'predict_prdct_wrap';
                            let productTitle = product.title;
                            let productUrl = product.url || `/products/${product.handle}`;
                            let productTitleSplit = productTitle.split('-');
                            let productImage = product.image ? product.image : 'placeholder.jpg';
                            resultItem.innerHTML = `
                                <a href="${productUrl}" class="predict_prdct_wrap">
                                    <img src="${productImage}" alt="${productTitleSplit[0]}">
                                    <div class="predict_prdct_info">
                                        <h3 class="qft_prdct_title">${productTitleSplit[0]}</h3>
                                        <p class="qftItalicTitle">${productTitleSplit[1]}</p>
                                        <p class="qft_price_wrap">${Shopify.formatMoney(product.price)}</p>
                                    </div>
                                </a>`;
                            searchResults.appendChild(resultItem);
                            // searchResultsMbl.appendChild(resultItem);
                        }
                    });
                    searchResultsBtn.innerHTML = `Search ${queryMbl}`;
                    searchResultsBtn.href = `/search?type=product&q=${queryMbl}`;
                    searchResultsBtn.style.display = 'block';
                    // searchResultsBtnMbl.innerHTML = `Search ${queryMbl}`;
                    // searchResultsBtnMbl.href = `/search?type=product&q=${queryMbl}`;
                    // searchResultsBtnMbl.style.display = 'block';
                    $('.search-res').show();
                } else {
                    searchResults.innerHTML = '<div>No products found</div>';
                    searchResultsBtn.style.display = 'none';
                    // searchResultsMbl.innerHTML = '<div>No products found</div>';
                    // searchResultsBtnMbl.style.display = 'none';
                }
            })
            .catch(error => {
                console.log('Error fetching predictive search results:', error);
            });
    });
    // Desktop input with keydown for enter detection
    $('#search-input-desk').on('keydown', function(el) {
        if (el.key === 'Enter') {
            el.preventDefault();
            let searchResultsBtnMbl = document.getElementById('search-btn-mbl');
            if (searchResultsBtnMbl && searchResultsBtnMbl.style.display !== 'none') {
                searchResultsBtnMbl.click();
            }
        }
    });

    // Mobile input with keydown for enter detection
    $('#search-input-mbl').on('keydown', function(el) {
        if (el.key === 'Enter') {
            el.preventDefault();
            let searchResultsBtn = document.getElementById('search-btn');
            if (searchResultsBtn && searchResultsBtn.style.display !== 'none') {
                searchResultsBtn.click();
            }
        }
    });
});


// wishlist 
// Function to get wishlist from localStorage
function getWishlist() {
    let wishlist = localStorage.getItem('wishlist');
    if (wishlist != "undefined") {
        return JSON.parse(wishlist);
    } else {
        return [];
    }
}

// Function to save wishlist to localStorage
function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

// Function to add or remove product from wishlist
function toggleWishlist(productHandle, button, wishlistPage) {
    // first Product Handle, Second Button itSelf and last Third Boolien for wishlist page
    let wishlist = getWishlist();
    wishlistPage = wishlistPage || false;
    if (!wishlist.includes(productHandle)) {
        wishlist.push(productHandle);
        saveWishlist(wishlist);
        button.classList.add('active')
    } else {
        wishlist = wishlist.filter(function (handle) {
            return handle !== productHandle;
        });
        saveWishlist(wishlist);
        button.classList.remove('active')
    }
    if (wishlistPage) {
        button.parentElement.parentElement.parentElement.remove();
        if (!document.getElementById('wishlist-items').hasChildNodes()) {
           document.getElementById('wishlist-items').innerHTML = '<p>Your wishlist is empty.</p>';
        }
    }
}

/* ---------------------------- Accordion Button ---------------------------- */
$('.acco-ttl').click(function () {
    let targetSelect = $(this).data('target');
    let cntBox = $(targetSelect);
    let img = $(this).find('span');

    if (cntBox.is(':hidden')) {
        cntBox.slideDown(200);
        img.html('-');
    }
    else {
        cntBox.slideUp(200);
        img.html('+');
    }
});
$('.question-list button').on('click', (el) => {
    $('.faq_blk_wrap').removeClass('active');
    $('.question-list button').removeClass('active-question');
    $(`#${el.currentTarget.dataset.target}`).addClass('active');
    el.currentTarget.classList.add('active-question');
});
$('.select-opts').change((el) => {
    let idWrap = $(el.currentTarget).find('option:selected').data('target');
    $('.faq_blk_wrap').removeClass('active');
    $(`#${idWrap}`).addClass('active');
})

// Initialize wishlist buttons
document.addEventListener('DOMContentLoaded', function () {
    const wishlistButtons = document.querySelectorAll('.wishlist-button');
    wishlistButtons.forEach(function (button) {
        const productHandle = button.getAttribute('data-product-handle');
        let wishlist = getWishlist();
        // Set button text based on whether the product is in the wishlist
        if (wishlist.includes(productHandle)) {
            button.classList.add('active')
        } else {
            button.classList.remove('active')
        }
        // Add event listener to handle click
        button.addEventListener('click', function () {
            toggleWishlist(productHandle, button);
        });
    });


    // // --------------- Start: Search Popup on mobile --------------- //
    // const openBtn = document.querySelector('[data-search-pop-open]');
    // const closeBtn = document.querySelector('[data-search-pop-close]');
    // const overlay = document.querySelector('.search_popup_overlay');
    // const input = overlay ? overlay.querySelector('input[type="search"], input[type="text"]') : null;
    // let searchResultsPop = document.getElementById('search-results-mbl');
    // let searchResultsPopBtnMbl = document.getElementById('search-btn-mbl');
    // if (openBtn && closeBtn && overlay && input) {
    //     openBtn.addEventListener('click', () => {
    //         overlay.classList.add('active');
    //         document.body.style.overflow = 'hidden';
    //         setTimeout(() => input.focus(), 100);
    //     });
    //     closeBtn.addEventListener('click', () => {
    //         overlay.classList.remove('active');
    //         document.body.style.overflow = '';
    //         input.value = '';
    //         input.blur();
    //         searchResultsPop.innerHTML = '';
    //         searchResultsPopBtnMbl.style.display = 'none';
    //         $('.search-res').hide();
    //     });
    // }
    // // --------------- End: Search Popup on mobile --------------- //
});


let windowURL = window.location.href;
if (windowURL.includes('products')) {
    // document.querySelector('product-info').offsetTop +
    let windowTopEl = document.querySelector('product-info').offsetHeight;
    toggleStickyBar();
    $(document).on('scroll', () => {
        toggleStickyBar();
    });
    function toggleStickyBar() {
        if (window.scrollY > windowTopEl && window.scrollY < document.querySelector('.qft-footer-mbl').parentElement.offsetTop) {
            $('.sticky_product_bar_wrap').slideDown();
        } else {
            $('.sticky_product_bar_wrap').slideUp();
        }
    }
    $('.sticky_product_bar_btn button').on('click', () => {
        $('.product-form__buttons .qft-add-button').click();
    });
}

